import { format$Price, formatPrice } from "utils/helpers/functions/formatPrice";
import { withLocalCurrency } from "utils/helpers/currency/currencyHelpers";
import vconst from "utils/helpers/structs/vconst";
import TableEmptyRow from "components/others/TableEmptyRow";
import { UserNameItem } from 'modules/user';
import { useObjectCard } from "../../context/ObjectCardProvider";
import { DateTime as DT } from "luxon";
import ExpendOtherActions from "./ExpendOtherActions";
import { Button } from "react-bootstrap";
import SvgEye from "components/svg/SvgEye";
import { useRef } from "react";
  
const ExpendOtherTableBody = ({expends, setShowSpinnerExpend, setShowExpendInfo, onlyView = false}) => {
    
    const refBtnView = useRef();
    
    return ( 
        <tbody>
            {expends?.map(expend=>{
                const dt = DT.fromMillis(expend.dt||0).toLocaleString(DT.DATE_MED);
                const dtCancel = DT.fromMillis(expend.dtCancel||0).toLocaleString(DT.DATE_MED);
                const amount = format$Price(expend.expendAmount, true);
                const amountRate = formatPrice(expend.expendAmountRate);
                
                return (
                    <tr className={`${expend.expendStatus === vconst.incomeStatCancel ? 'bg-light-danger' :''}`}
                        key={expend.ID}>
                        <td className="user">
                            <UserNameItem
                                user={{
                                    userName       : expend.userName,
                                    userEmail      : expend.userEmail,
                                    userPicture    : expend.userPicture
                                }}/>
                        </td>
                        <td className="team">
                            <h6 className={`mb-1 text-break `}>{expend.expendName}</h6>
                            <div className={onlyView ? '' : `d-md-none`}>
                                <p className="text-muted f-12 mb-0 my-1">{dt} </p>
                            </div>
                        </td>
                        {!onlyView &&
                        (<td className="date">
                            <h6 className="mb-1 text-break">{dt}</h6>
                            {expend.expendStatus === vconst.incomeStatCancel && 
                            (<p className={`text-danger fw-medium fs-12 mb-0 my-1 text-truncate`}>{dtCancel}</p>)}
                        </td>)}
                        <td className="amount">
                            {expend.expendStatus === vconst.incomeStatCancel 
                            ?(<h6 className={`mb-1 text-truncate text-muted`}>{amount}</h6>)
                            :(<h6 className={`mb-1 text-truncate ${expend.expendAmount>0 ? 'text-success' : 'text-danger'}`}>{amount}</h6>)}
                            <p className="text-muted f-12 mb-0 my-1 text-truncate">{withLocalCurrency(amountRate)}</p> 
                        </td>
                        <td className="actions">
                        {onlyView 
                            ? (<>
                            <Button
                                className="p-1 py-0" 
                                ref={refBtnView}
                                size="sm" 
                                variant="light-secondary" 
                                onClick={(e)=>{
                                    e.target?.blur();
                                    e.target?.parentNode?.blur();
                                    refBtnView?.current?.blur();
                                    setShowExpendInfo(expend.ID)
                                }}><i className="bi bi-eye"></i></Button>
                            </>)
                            :(<ExpendOtherActions 
                                setShowExpendInfo={setShowExpendInfo}
                                setShowSpinnerExpend={setShowSpinnerExpend}
                                expend={expend}/>)} 
                        </td>
                    </tr>
                )
            })}

            {(!expends || expends?.length === 0) && (
                <TableEmptyRow colSpan={5} />
            )}
        </tbody>
    )
}

export default ExpendOtherTableBody;